export default {
  VERSIONS_MODAL: {
    TITLE: `Versions`,
    SUMMARY: ``
  },
  FEATURES: `Features`,
  IMPROVEMENTS: `Improvements`,
  FIXES: `Fixes`
}
